<router-outlet></router-outlet>
<ngx-bootstrap-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#fff" type="grow" [fullScreen]="true"
    loaderTemplate="<img src='../../../assets/img/newloaer.png' alt='loader img' style='height: 100px; width: auto;' />">
</ngx-bootstrap-spinner>